"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSpecialtyUpdateDto = instanceOfSpecialtyUpdateDto;
exports.SpecialtyUpdateDtoFromJSON = SpecialtyUpdateDtoFromJSON;
exports.SpecialtyUpdateDtoFromJSONTyped = SpecialtyUpdateDtoFromJSONTyped;
exports.SpecialtyUpdateDtoToJSON = SpecialtyUpdateDtoToJSON;
exports.SpecialtyUpdateDtoToJSONTyped = SpecialtyUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the SpecialtyUpdateDto interface.
 */
function instanceOfSpecialtyUpdateDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('assessmentIds' in value) || value['assessmentIds'] === undefined)
        return false;
    return true;
}
function SpecialtyUpdateDtoFromJSON(json) {
    return SpecialtyUpdateDtoFromJSONTyped(json, false);
}
function SpecialtyUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'assessmentIds': json['assessmentIds'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
function SpecialtyUpdateDtoToJSON(json) {
    return SpecialtyUpdateDtoToJSONTyped(json, false);
}
function SpecialtyUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'assessmentIds': value['assessmentIds'],
        'active': value['active'],
    };
}
//# sourceMappingURL=SpecialtyUpdateDto.js.map